import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Lock, ArrowLeft } from "lucide-react";
import { adminLogin } from "@/lib/auth";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await adminLogin(form.email, form.password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-6 grain" data-testid="admin-login">
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0a0a0a] via-[#050505] to-[#0a0a0a]" />
        <div
          className="absolute inset-0 opacity-30"
          style={{ background: "radial-gradient(600px 400px at 50% 0%, rgba(229,169,61,0.18), transparent)" }}
        />
      </div>

      <div className="w-full max-w-md surface-elevated p-8 lg:p-10">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-neutral-400 hover:text-amber-500 mb-6">
          <ArrowLeft size={14} /> Back to site
        </Link>
        <div className="overline">Admin</div>
        <h1 className="mt-2 font-display text-3xl tracking-tighter">Fundle Console</h1>
        <p className="mt-2 text-sm text-neutral-400">Sign in to manage malls, advertisers and bookings.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <label className="block">
            <div className="text-xs uppercase tracking-[0.18em] text-neutral-500 mb-2">Email</div>
            <input
              data-testid="admin-login-email"
              type="email"
              autoComplete="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
            />
          </label>
          <label className="block">
            <div className="text-xs uppercase tracking-[0.18em] text-neutral-500 mb-2">Password</div>
            <input
              data-testid="admin-login-password"
              type="password"
              autoComplete="current-password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              required
            />
          </label>
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="btn-primary w-full justify-center">
            <Lock size={14} /> {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <div className="mt-6 text-xs text-neutral-500">
          Authorised personnel only. Failed attempts are rate-limited.
        </div>
      </div>
    </div>
  );
}
